define('plugin/invoice/view/InvoicePaymentMethodView',['require','plugin/invoice/view/InvoicePaymentSystemView'],function (require) {

    var InvoicePaymentSystemView = require('plugin/invoice/view/InvoicePaymentSystemView');

    /**
     * @class InvoicePaymentMethodView
     */
    return InvoicePaymentSystemView.extend({

        template: '#invoice_payment_method_view',
        childViewContainer: '#sb_invoice_payment_method_container',
        collectionEvents: {
            'sync': 'render'
        },

        filter: function () {
            return true;
        },

    });

});
